(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-marken-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-marken-promo')) {
    customElements.define('cc-marken-promo', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cc-mp__track');
        this.pages = [...this.querySelectorAll('.cc-mp__page')];
        this.items = [...this.querySelectorAll('.cc-mp__item')];
        this.arrows = this.querySelectorAll('.cc-mp__arrow');
        this.status = this.querySelector('.cc-mp__status');
        this.more = this.querySelector('.cc-mp__more');
        this.mqStacked = window.matchMedia('(max-width: 989px)');
        this.mqSmall = window.matchMedia('(max-width: 749px)');

        // Tablet/Mobil: festes Raster, „Mehr anzeigen“ klappt weitere Reihen auf
        const relayout = () => { this.layout(true); this.update(); };
        this.mqStacked.addEventListener('change', relayout);
        this.mqSmall.addEventListener('change', relayout);
        if (this.more) this.more.addEventListener('click', () => this.showMore());

        // Desktop: Seiten à 12, blättern per Pfeil
        this.arrows.forEach((btn) => btn.addEventListener('click', () => this.go(Number(btn.dataset.dir))));
        if (this.track) {
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.t);
            this.t = setTimeout(() => this.update(), 80);
          }, { passive: true });
        }

        this.layout(true);
        this.update();
        this.classList.add('is-ready');
      }
      steps() {
        return this.mqSmall.matches ? { first: 4, step: 6 } : { first: 8, step: 8 };
      }
      layout(reset) {
        if (!this.mqStacked.matches) {
          this.items.forEach((li) => { li.hidden = false; });
          if (this.more) this.more.hidden = true;
          return;
        }
        if (reset) this.shown = this.steps().first;
        this.items.forEach((li, n) => { li.hidden = n >= this.shown; });
        if (this.more) this.more.hidden = this.shown >= this.items.length;
      }
      showMore() {
        const from = this.shown;
        this.shown += this.steps().step;
        this.layout(false);
        const next = this.items[from] && this.items[from].querySelector('a[href]');
        if (next) next.focus({ preventScroll: true });
      }
      current() {
        return this.track && this.track.clientWidth ? Math.round(this.track.scrollLeft / this.track.clientWidth) : 0;
      }
      go(dir) {
        const target = Math.max(0, Math.min(this.pages.length - 1, this.current() + dir));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }
      update() {
        if (this.mqStacked.matches || this.pages.length < 2) {
          this.pages.forEach((page) => page.removeAttribute('inert'));
          return;
        }
        const i = this.current();
        this.arrows[0].disabled = i === 0;
        this.arrows[1].disabled = i >= this.pages.length - 1;
        if (this.status) this.status.textContent = `${i + 1} / ${this.pages.length}`;
        this.pages.forEach((page, n) => page.toggleAttribute('inert', n !== i));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Header liegt in einer Section-Group → echte ID ist `…__header`, nicht `shopify-section-header`
      // (Letzteres existiert nur als CSS-Klasse). getElementById gäbe null → observe(null) +
      // null.classList in hide()/reveal()/sticky() würden Sticky-Header UND jeden Mobile-Dock-Klick brechen.
      // Fallback per closest('.shopify-section') findet den Header-Wrapper elementrelativ und robust.
      this.header = document.getElementById('shopify-section-header') || this.closest('.shopify-section');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;

          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      // Body-Klassen spiegeln, damit Sektionen wie der Mobile-Dock auf den Sticky-Header-Zustand
      // reagieren können (section-mobile-dock.css / section-popup.css erwarten sie, niemand setzte sie).
      document.body.classList.add('shopify-body-section-header-sticky', 'shopify-body-section-header-hidden');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-body-section-header-sticky', 'shopify-body-section-header-hidden');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
